import React from 'react';
import { motion } from 'framer-motion';
import { Filter } from 'lucide-react';
import { CategoryDropdown } from './CategoryDropdown';
import { PriceRangeFilter } from './PriceRangeFilter';
import { useProducts } from '../../../context/ProductContext';

export const FilterContainer: React.FC = () => {
  const { filteredProducts } = useProducts();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg shadow-lg p-6 mb-6"
    >
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-2">
          <Filter className="text-orange-500" size={20} />
          <h3 className="font-medium">Filtros de búsqueda</h3>
        </div>
        <span className="text-sm text-gray-600">
          {filteredProducts.length} productos encontrados
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <CategoryDropdown />
        <PriceRangeFilter />
      </div>
    </motion.div>
  );
};